import { LookupService } from '../../../services/lookup.service';
import { Component, ElementRef, HostListener, inject, OnDestroy, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { ParticipantInformationComponent } from '../../leads/participant-information/participant-information.component';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { HorizontalMenuItem, MainMenuItem, MenuItem } from '../../../interfaces/menu.interface';

import { CommonModule } from '@angular/common';
import { SectionsService } from '../../../services/sections.service';
import { BaseComponent } from '../../../shared/utils/base.component';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { LeadCommentsComponent } from '../lead-comments/lead-comments.component';
import { PARTICIPANT_LIMITED_ACCESS_PAGES, STATIC_DATA, STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { ActionsComponent } from '../../../shared/components/actions/actions.component';
import { ListService } from '../../../shared/services/list.service';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { NgZorroModule } from '../../../shared/modules/ng-zorro/ng-zorro.module';
import { LoggerService } from '../../../shared/services/logger.service';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { MEMBER_VIEW_PAGE_IDS } from '../../../shared/constants/page.constants';
import { NotificationSMSComponent } from '../../../shared/modals/notification-sms/notification-sms.component';
import { ErrorAlertService } from '../../../shared/services/error-alert.service';
import { AuthorizationService } from '../../../shared/authorization/authorization.service';
import { TimelineComponent } from "../../../shared/components/timeline/timeline.component";
import { SideDrawerComponent } from "../../../shared/components/side-drawer/side-drawer.component";
import { AuthorizeDirective } from '../../../shared/authorization/authorize.directive.';
import { CommunicationLogsComponent } from "../communication-logs/communication-logs.component";
import { environment } from '../../../../environments/environment';
import { ReferralDataService } from '../../../services/referral-data.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { SurveyComponent } from '../../../shared/components/survey/survey.component';

@Component({
  selector: 'ppl-authorization-member-view',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NgZorroModule,
    LeadCommentsComponent,
    ActionsComponent,
    ButtonComponent,
    NotificationSMSComponent,
    TimelineComponent,
    SideDrawerComponent,
    AuthorizeDirective,
    CommunicationLogsComponent,
    SurveyComponent,
  ],
  providers: [ListService],
  templateUrl: './member-view.component.html',
  styleUrl: './member-view.component.css',
})
export class MemberViewComponent extends BaseComponent implements OnInit, OnDestroy {
  horizontalMenuItemstoDisplay: any;
  selectedMenuItem: any;
  enableComments = false;
  changedCLass = '';
  filledInfo: any;
  id: any;
  applicationData: any[] = [];
  listButton: any[] = [];

  applicationStatusList: any;
  entry: any;
  sectionDataPath: string = STATIC_JSON_DATA_PATH.LEAD_DETAILS_SECTION_DATA;
  program: any;
  pageId = '';
  tabId = '';
  tabsToBeHidden: string[] = [];
  buttonsToBeHidden: string[] = [];
  actionToBeHidden: string[] = [];
  steps: any;
  showSMSModal: any = '';
  notificationType = '';
  mobileNumber: string[] = [];
  emailId: string[] = [];
  isPageRestrictionLoaded = false;
  auditHistory: any;
  backLabel = "Back";
  leadData: any;
  isCommunicationLogs = false;
  pbiReport = false;
  showSurvey = false;
  showSurveyBtn = false;
  isPA = false;
  detailPageBaseUrl = '';
  isExternalEnvironment = false;
  @ViewChild('mobileMainMenu', { static: false }) mobileMainMenu: any;
  @ViewChildren('tabButton') tabButtons!: QueryList<ElementRef>;
  @ViewChild('tabPanel') tabPanel!: ElementRef;

  // selectedMenuItem: string = '';

  isMobileView = window.innerWidth <= 768;

  constructor(
    private leadDetailsService: LeadDetailsService,
    private router: Router,
    private sectionsService: SectionsService,
    private loggerService: LoggerService,
    private authUtility: AuthorizationUtility,
    private listService: ListService,
    private authService: AuthorizationService,
    private referralDataService: ReferralDataService,
    private userService: UserService,
    private storageService: StorageService,
  ) {
    super();
  }
  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.isExternalEnvironment = environment.isExternal;


    if (this.router.url == "/home/providerEnrollmentList/details/forms") {
      this.detailPageBaseUrl = "/home/providerEnrollmentList/details"
    } else if (this.router.url.endsWith('/summary')) {
      this.detailPageBaseUrl = this.router.url.substring(0, this.router.url.lastIndexOf('/'));
    } else {
      this.detailPageBaseUrl = this.router.url;
    }

    this.program = this.userService.getSelectedProgram();
    this.entry = this.userService.getLeadEntry();

    this.id = JSON.parse(this.userService.getSelectedLead()!);


    this.pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
    this.setPageAccess();

    /* this.backLabel = DETAIL_PAGE_BACKBUTTON[this.entry]; */
    /* if(this.entry == STATIC_DATA.REFERRAL){
      this.backLabel = "Back to Referrals";
    }
    else if(this.entry == 'participant'){
      this.backLabel = "Back to Participant Lead";
    }
    else if(this.entry == 'participantEnrollment'){
      this.backLabel = "Back to Participant Enrollment";
    }
    else{
      this.backLabel = "Back to Provider Lead";
    } */
    this.sectionsService.tabChangedEvent$.subscribe((tab: any) => {
      if(tab) {
        this.selectedMenuItem = tab;
      }
    });

    this.leadDetailsService.getUpdatedLeadData().subscribe((data) => {
      this.leadData = data;
      this.filledInfo =
        data?.responsedata?.infoData;

    })

    const userDetails = this.userService.getUserDetails();
    const userRoles = userDetails?.programs.find(pr => pr.program_code === this.program.program_code)?.roles;
    const providerType = this.sectionsService.getEnrollmentType();
    if (Array.isArray(providerType) && providerType.includes('provider')) {
      this.isPA = true;
    }
    this.showSurveyBtn = userRoles?.some(r => r.role_name === 'PPL Admin' || r.role_name === 'Compliance') ?? false;

  }

  private readonly ASSIGN_APPROVAL_BUTTON_IDS = ['assign_to_user', 'assign_to_me', 'Approve', 'Deny', 'Resurrect', 'review_complete'];
  private readonly NOTIFICATION_BUTTON_IDS = ['send_sms', 'send_email'];

  private getRoleRestrictedButtonIds(): string[] {
    if (this.entry !== STATIC_DATA.REFERRAL) {
      return [];
    }
    const hidden: string[] = [];
    if (this.userService.isInRole(['LDSS Role', 'MCO Admin', 'MCO Super Admin', 'PAVAdmin', 'PAVTraining', 'Enrollment Specialist', 'Fulfillment Staff'])) {
      hidden.push(...this.ASSIGN_APPROVAL_BUTTON_IDS);
    }
    if (this.userService.isInRole(['LDSS Role', 'MCO Admin', 'MCO Super Admin', 'Enrollment Specialist', 'Fulfillment Staff'])) {
      hidden.push(...this.NOTIFICATION_BUTTON_IDS);
    }
    return hidden;
  }

  private loadData() {
    try {
      if (this.program.program_code) {
        this.getMenuItems();
      }

      this.leadDetailsService.getUpdatedLeadData().subscribe((data) => {
        const communicationData = data?.responsedata?.communicationData;
        if (communicationData?.contactMethods) {
          this.mobileNumber = communicationData.contactMethods
            .filter((contact: any) => contact.contactMethod === 'mobile')
            .map((contact: any) => contact.value);
          this.emailId = communicationData.contactMethods
            .filter((contact: any) => contact.contactMethod === 'email')
            .map((contact: any) => contact.value);
        }
        this.filledInfo =
          data?.responsedata?.infoData;
        /* this.id = (this.entry == STATIC_DATA.REFERRAL) ? this.filledInfo?.referralId : this.filledInfo?.leadId; */

        if (this.filledInfo) {
          this.applicationData = [
            {
              application_status_lkp: this.filledInfo?.applicationStatus,
              leadId: this.id,
              mobile_number: this.mobileNumber || [],
              email_id: this.emailId || [],
            },
          ];
          this.listService.setApplicationData(this.applicationData);
          if (this.filledInfo?.applicationStatus?.toLowerCase() == 'approved' || this.filledInfo?.applicationStatus?.toLowerCase() == 'enrollment complete'
          || (this.entry === STATIC_DATA.REFERRAL && this.filledInfo?.applicationStatus?.toLowerCase() == 'review complete')) {
            this.listButton = [{
              button_id: "send_sms",
              button_label: "Send SMS",
              buttonAction: "sendSMS",
              className: "primary-btn-color"
            },
            {
              button_id: "send_email",
              button_label: "Send Email",
              buttonAction: "sendEmail",
              className: "primary-btn-color"
            }];
          } else if (
            this.filledInfo?.applicationStatus?.toLowerCase() == 'denied' || this.filledInfo?.applicationStatus?.toLowerCase() == 'disenrolled'
          ) {
            this.listButton = [
              {
                button_id: 'Resurrect',
                button_label: 'Resurrect',
                buttonAction: 'Resurrect',
                className: 'primary-btn-color',
              },
              {
                button_id: "send_sms",
                button_label: "Send SMS",
                buttonAction: "sendSMS",
                className: "primary-btn-color"
              },
              {
                button_id: "send_email",
                button_label: "Send Email",
                buttonAction: "sendEmail",
                className: "primary-btn-color"
              }
            ];
          } else {
            this.listButton = [
              {
                button_id: 'assign_to_user',
                button_label: 'Assign to User',
                buttonAction: 'assign_to_user',
                className: 'primary-btn-color',
              },
              {
                button_id: 'assign_to_me',
                button_label: 'Assign to Me',
                buttonAction: 'assign_to_me',
                className: 'primary-btn-color',
              },
              {
                button_id: 'Approve',
                button_label: 'Approve',
                buttonAction: 'approve',
                className: 'primary-btn-color',
              },
              {
                button_id: 'Deny',
                button_label: 'Deny',
                buttonAction: 'Deny',
                className: 'primary-btn-color',
              },
              {
                button_id: "send_sms",
                button_label: "Send SMS",
                buttonAction: "sendSMS",
                className: "primary-btn-color"
              },
              {
                button_id: "send_email",
                button_label: "Send Email",
                buttonAction: "sendEmail",
                className: "primary-btn-color"
              }

            ];
          }

          if (this.entry === STATIC_DATA.PARTICIPANT_ENROLLMENT) {
            this.listButton = this.listButton.filter(button => button.button_id !== 'Approve' && button.button_id !== 'Deny' && button.button_id !== 'Resurrect');
            this.listButton.push(
              {
                button_id: "send_registration",
                button_label: "Resend Registration Link",
                buttonAction: "send_registration",
                className: "primary-btn-color"
              },
              // {
              //   button_id:"update_status",
              //   button_label:"Update Status",
              //   buttonAction : "update_status",
              //   className: "primary-btn-color"
              // }
            );
          } else if (this.entry === STATIC_DATA.PROVIDER_ENROLLMENT) {
            this.listButton = this.listButton.filter(button => button.button_id !== 'Approve' && button.button_id !== 'Deny' && button.button_id !== 'Resurrect');
            this.listButton.push(
              {
                button_id: "send_registration",
                button_label: "Resend Registration Link",
                buttonAction: "send_registration",
                className: "primary-btn-color"
              });
          } else if (this.entry === STATIC_DATA.REFERRAL) {
            if (this.filledInfo?.applicationStatus?.toLowerCase() == 'review needed') {
            this.listButton = this.listButton.filter(button => button.button_id !== 'Resurrect');
            this.listButton.push(
              {
                button_id: "review_complete",
                button_label: "Review Complete",
                buttonAction: "review_complete",
                className: "primary-btn-color"
              });
            };
          }
          this.listButton = [...this.listButton];
          this.listButton = this.getAuthorizedActions(this.listButton);
          const roleRestrictedButtonIds = this.getRoleRestrictedButtonIds();
          this.listButton = this.listButton.filter(button =>
            !roleRestrictedButtonIds.some(id => id.toLowerCase() === button.button_id.toLowerCase())
          );
        }
      })
    } catch (e) {
      this.loggerService.info('Error in loading data', e);
    }

    this.getLeadData()
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService.fetchPageAuthorization(this.program.program_code, this.pageId, "DETAIL").subscribe(response => {
        this.setRestrictions(response);
      })
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  private setRestrictions(pageConfig: any) {
    if (pageConfig) {
      this.tabsToBeHidden = this.authUtility.getHiddenTabs(pageConfig, this.pageId);
      this.actionToBeHidden = this.authUtility.getHiddenActions(pageConfig, this.pageId);
      this.buttonsToBeHidden = this.authUtility.getHiddenButtons(pageConfig, this.pageId);
    }
    this.isPageRestrictionLoaded = true;
    this.loadData();
  }

  getAuthorizedTabs(tabs: any[]) {
    return tabs.filter(c => this.tabsToBeHidden.find(hc => hc.toLowerCase() === c.menu_id.toLowerCase()) === undefined);
  }

  getAuthorizedButtons(buttons: any[]) {
    return buttons.filter(c => this.buttonsToBeHidden.find(hc => hc.toLowerCase() === c.button_id.toLowerCase()) === undefined);
  }

  getAuthorizedActions(actions: any[]) {
    return actions.filter(c => this.actionToBeHidden.find(hc => hc.toLowerCase() === c.button_id.toLowerCase()) === undefined);
  }

  async getMenuItems() {
    try {
      if (this.entry) {
        const menu = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.LEAD_DETAILS_MENU,
          this.entry
        );
        this.horizontalMenuItemstoDisplay = this.getAuthorizedTabs(this.filterHorizontalMenuItems(
          menu.horizontal_menu
        ));
      }
    } catch (e) {
      console.log('error fetching menu items: ', e);
    }

    const navigateToTab = history?.state?.['navigateToTab'];
    const foundTab = this.horizontalMenuItemstoDisplay.find((menuItem: MenuItem) => {
      return menuItem?.menu_id?.toLowerCase() === (navigateToTab?.toLowerCase() || this.horizontalMenuItemstoDisplay[0]?.menu_id?.toLowerCase());
    });

    this.selectedMenuItem = foundTab?.menu_id;
    await this.getSectionData();


    this.router.navigate([
      `${this.detailPageBaseUrl}/${foundTab.landing_component}`,
    ], { state: history.state });

    /* if (this.entry == 'participant') {
      this.router.navigate([
        `/home/participantLeadsList/leadDetails/${this.horizontalMenuItemstoDisplay[0].landing_component}`,
      ]);
    } else {
      this.router.navigate([
        `/home/providerLeadsList/leadDetails/${this.horizontalMenuItemstoDisplay[0].landing_component}`,
      ]);
    } */
  }

  focusTabPanel() {
    setTimeout(() => {
      this.tabPanel?.nativeElement?.focus();
    }, 0);
  }
  onPanelKeydown(event: KeyboardEvent) {
    if (event.shiftKey && event.key === 'Tab') {
      const focusableElements = this.getFocusableElements(this.tabPanel.nativeElement);
    const current = document.activeElement as HTMLElement;

    const index = focusableElements.findIndex(el => el === current);

  
      if (index === 0) {
        event.preventDefault();
  
        const index = this.horizontalMenuItemstoDisplay.findIndex(
          (item: any) => item.menu_id === this.selectedMenuItem
        );
  
        this.tabButtons.get(index)?.nativeElement?.focus();
      }
    }
  }

  getFocusableElements(container: HTMLElement): HTMLElement[] {
    const focusableSelectors = [
      'a[href]',
      'area[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
      '[contenteditable="true"]'
    ];
  
    return Array.from(
      container.querySelectorAll(focusableSelectors.join(','))
    )
      .filter((el): el is HTMLElement =>
        el instanceof HTMLElement &&
        !el.hasAttribute('disabled') &&
        !el.getAttribute('aria-hidden')
      );
  }

  async getSectionData() {
    try {
      if (this.entry) {
        this.steps = await this.sectionsService.getJsonConfigurationData(
          this.sectionDataPath,
          this.entry
        );
        this.secData = this.steps['participant_info'];
      }
    } catch (e) {
      console.log('error fetching section data: ', e);
    }
  }

  filterHorizontalMenuItems = (menu: HorizontalMenuItem) => {
    var tabs = menu.filter((menuItem: MenuItem) => {
      return menuItem.display == 'y';
    });

    const enrollmentTypes = this.sectionsService.getEnrollmentType();
    if (enrollmentTypes && enrollmentTypes.length > 0 && enrollmentTypes.indexOf('provider') == -1) {
      tabs = tabs.filter(e => e.menu_id !== 'timesheets' && e.menu_id !== 'benefits' && e.menu_id !== 'taxDocuments')
    }

    if (this.isMobileView) {
      tabs = tabs.filter(e => e.menu_id !== 'checklist' && e.menu_id !== 'benefits' && e.menu_id !== 'additionalAttributes')
    }

    return tabs;
  };

  onMenuSelection = (menuSelected: any) => {
    this.selectedMenuItem = menuSelected.menu_id;
    if (this.mobileMainMenu) {
      this.mobileMainMenu.nativeElement.classList.remove('show');  // Manually remove the 'show' class
    }
    this.router.navigate([
      `${this.detailPageBaseUrl}/${menuSelected.landing_component}`,
    ], { state: history.state });

    /* if (this.entry == 'participant')
      this.router.navigate([
        `/home/participantLeadsList/leadDetails/${menuSelected.landing_component}`,
      ]);
    else {
      this.router.navigate([
        `/home/providerLeadsList/leadDetails/${menuSelected.landing_component}`,
      ]);
    } */
    /* this.menuService.setSelectedMenu(menuSelected); */
  };


  getUrlForBackButton(): string {
    // Get the current URL
    const currentUrl = this.router.url;
    const urlSegments = currentUrl.split('/'); // Split the URL by '/' and remove the last segment
    urlSegments.splice(-2); // Remove the last two segment
    const newUrl = urlSegments.join('/'); // Join the remaining segments to form the URL
    console.log(newUrl); // Logs the URL without the last segment
    const navigateToTab: string = history?.state['navigateToTab'];
    const navigateLeadId: string = history?.state['leadId'];
    const navigateToproviderType: string = history?.state['providerType'];

    if (navigateToTab === 'checklist') {
      urlSegments.splice(-1);
      urlSegments.push('fileTriage');
      return urlSegments.join('/');
    };

    if (navigateToTab === 'documents') {
      urlSegments.splice(-1);
      urlSegments.push('fileUploadNotification');
      return urlSegments.join('/');
    };

    if (navigateToTab == "summary" && navigateLeadId) {
      //assume user coming from manage consumer action then redirect him to associations of provider details page
      this.referralDataService.clearReferrralData();
      this.userService.setLeadEntry('providerEnrollment');
      this.sectionsService.setFlow('providerEnrollment');
      this.userService.setSelectedLead(navigateLeadId);
      this.sectionsService.setEnrollmentType(
        JSON.stringify(navigateToproviderType)
      );
      this.sectionsService.setAssocType(
        JSON.stringify(navigateToproviderType)
      );
       this.userService.setFirstSegment('providerEnrollmentList');
      return '/home/providerEnrollmentList/details/';
    };

    return newUrl;
  }

  comments() {
    this.enableComments = !this.enableComments;
  }

  getValue(code: string, valueOf: string) {
    let check;
    if (valueOf == 'status') {
      check = this.applicationStatusList;
    } else if (valueOf == 'stage') {
      check = this.applicationStatusList;
    }

    return this.lookupService.getLookupName(check, code);
  }

  // new UI changes

  isTempZActive = false;
  isAuditHistory = false;

  toggleTempZ() {
    this.isTempZActive = !this.isTempZActive; // Toggle the state when the button is clicked
  }

  closeDropdown() {
    this.isTempZActive = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-container')) {
      this.closeDropdown();
    }
  }
  leadId: string | null = null;

  navigateToLeads() {
    const navigateToTab: string = history?.state['navigateToTab'];
    const navigateTo: string = history?.state['navigateTo'];

    if (navigateTo) {
      this.router.navigate([
        navigateTo,
      ]);
      return;
    }

    if (environment.isExternal && !navigateToTab && this.entry !== STATIC_DATA.REFERRAL) {
      this.router.navigate([
        `/`,
      ]);
      return;
    }

    this.router.navigate([
      `${this.getUrlForBackButton()}`,
    ]);

    /* if ( this.entry == 'participant') {
      this.router.navigate([
        `/home/participantLeadsList/`,
      ]);
    } 
    else if(this.entry == 'referral'){
      this.router.navigate([
        `/home/referralList/`,
      ]);
    }else {
      this.router.navigate([
        `/home/providerLeadsList/`,
      ]);
    } */
  }

  getUpdatedLeadData = (event: boolean) => {
    if (event) {
      this.getLeadData(true);
    }
  };

  getLeadHistory() {

    const entry = this.leadDetailsService.getEntry(this.entry); // this is a special case where the url path parameter is not the same as the UI entry variable
    this.leadDetailsService.getLeadAuditHistory(this.program.program_code, entry,
      this.id).subscribe(data => {
        this.auditHistory = data.responsedata;
        this.isAuditHistory = true;
      });
  }

  communicationLogs() {
    this.isCommunicationLogs = true;
  }

  openSurvey() {
    this.showSurvey = true;
  }
  // sendNotification(type: string) {
  //   const values = type == 'sms' ? this.mobileNumber : this.emailId;
  //   this.notificationType = type == 'sms' ? 'mobile number' : 'email address';
  //   if (!values.length || (values.length && values.some((val) => val === ''))) {
  //     const errorMessage = `Note that the ${this.notificationType} is currently absent in the Contact Details section of profile. Please specify the ${this.notificationType} before continuing.`;
  //     this.errorAlertService.openModal('error', 'Error', errorMessage, '');
  //   } else {
  //     this.showSMSModal = 'sms';
  //   }
  // }

  onHandleCancel(event: any) {
    this.showSMSModal = event;
  }



  getLeadData(isAfterUpdate = false) {
    /* const id = JSON.parse(this.userService.getSelectedLead()!); */
    this.leadDetailsService
      .fetchLeadDetailsApi(
        this.entry,
        this.program.program_code,
        this.id,
        isAfterUpdate
      )
      .subscribe((data: any) => {
        if (this.entry === STATIC_DATA.PROVIDER_ENROLLMENT) {
          this.filledInfo = data?.responsedata?.basicInfo;
        } else {
          this.filledInfo = data?.responsedata?.infoData;
          this.referralDataService.setDemographicData(
            data.responsedata?.infoData
          );
          if (this.entry === STATIC_DATA.PARTICIPANT_ENROLLMENT) {
            this.storageService.setReferralConsumerId(data.responsedata?.infoData?.referralId);
          }
        }
      });
  }
}
